const isDebug = false;
const baseStyles = [
  "color: #fff",
  "background-color: #1779E1",
  "padding: 2px 8px",
  "border-radius: 4px",
].join(";");
function consoleLog() {
  if (window.console && isDebug === true) {
    console.log(
      "%cDREAM",
      baseStyles,
      ...Array.prototype.slice.call(arguments)
    );
  }
}

let nextURLElement = null;
let nextURL = null;
let isTrying = false;
let noMore = false;

function getNextPage() {
  if (isTrying === true || noMore === true || nextURL === null) return;

  if (
    document.documentElement.scrollHeight - 5000 <
    window.scrollY + window.innerHeight
  ) {
    consoleLog(`GET ${nextURL}`);
    isTrying = true;

    const productList = document.querySelector(".product-list");

    const xhr = new XMLHttpRequest();
    xhr.open("GET", nextURL);
    xhr.setRequestHeader("Content-Type", "text/html");
    xhr.onreadystatechange = function () {
      isTrying = false;

      if (xhr.readyState === 4 && xhr.status === 200) {
        const parser = new DOMParser();
        const responseDoc = parser.parseFromString(
          xhr.responseText,
          "text/html"
        );
        const filteredData = responseDoc.querySelectorAll(".product-card");
        const combinedHTML = Array.from(filteredData).reduce(function (
          html,
          element
        ) {
          return html + element.outerHTML;
        },
        "");

        productList.insertAdjacentHTML("beforeend", combinedHTML);

        const potentialNextURL = responseDoc.querySelector(".product__next a");

        if (potentialNextURL === null) {
          consoleLog("No more pages");
          noMore = true;
          const next = document.querySelector(".collection__results .product__next");
          if (next) {
            next.style.display = "none";
          }
          return;
        }

        nextURL = potentialNextURL.getAttribute("href");
      }
    };
    xhr.send();
  }
}

document.addEventListener("DOMContentLoaded", function () {
  nextURLElement = document.querySelector(".collection__results .product__next a");
  if (nextURLElement !== null) nextURL = nextURLElement.getAttribute("href");

  window.addEventListener("scroll", function () {
    clearTimeout(window.scrollTimeout);
    window.scrollTimeout = setTimeout(getNextPage, 100);
  });

  document.addEventListener("facet:updated", async (event) => {
    // prevent multiple calls
    clearTimeout(window.scrollTimeout);

    consoleLog("Facet updated");
    consoleLog(`Old - GET ${nextURL}`);
    
    // reset nextURL
    nextURLElement = document.querySelector(".collection__results .product__next a");
    if (nextURLElement !== null) {
      nextURL = nextURLElement.getAttribute("href");
    } else {
      consoleLog("No more pages");
      noMore = true;
      const next = document.querySelector(".collection__results .product__next");
      if (next) {
        next.style.display = "none";
      }
      return;
    }
    consoleLog(`GET ${nextURL}`);

    // reset to allow pagination again
    window.scrollTimeout = setTimeout(getNextPage, 100);
    noMore = false;
  });
});
